import { WifiOff, RefreshCw, Upload } from 'lucide-react';

interface OfflineBannerProps {
  isOnline: boolean;
  pendingCount: number;
  isSyncing: boolean;
  onSyncNow?: () => void;
}

export default function OfflineBanner({ isOnline, pendingCount, isSyncing, onSyncNow }: OfflineBannerProps) {
  if (isOnline && pendingCount === 0) return null;

  if (!isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[99999] flex items-center justify-center gap-2 px-4 py-2 text-[11px] font-semibold text-white"
        style={{ background: 'rgba(239,68,68,0.95)', backdropFilter: 'blur(8px)' }}
      >
        <WifiOff className="w-3.5 h-3.5 flex-shrink-0" />
        <span>OFFLINE — actions will sync when reconnected</span>
        {pendingCount > 0 && (
          <span className="ml-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-white/20">
            {pendingCount} queued
          </span>
        )}
      </div>
    );
  }

  // Online but still has pending items to sync
  return (
    <div className="fixed top-0 left-0 right-0 z-[99999] flex items-center justify-center gap-2 px-4 py-2 text-[11px] font-semibold text-white"
      style={{ background: 'rgba(245,158,11,0.95)', backdropFilter: 'blur(8px)' }}
    >
      {isSyncing ? (
        <>
          <RefreshCw className="w-3.5 h-3.5 animate-spin flex-shrink-0" />
          <span>Syncing {pendingCount} queued action{pendingCount !== 1 ? 's' : ''}...</span>
        </>
      ) : (
        <>
          <Upload className="w-3.5 h-3.5 flex-shrink-0" />
          <span>{pendingCount} action{pendingCount !== 1 ? 's' : ''} pending sync</span>
          {onSyncNow && (
            <button onClick={onSyncNow}
              className="ml-2 px-2 py-0.5 rounded-full text-[9px] font-bold bg-white/25 hover:bg-white/40 transition-colors"
            >
              Sync now
            </button>
          )}
        </>
      )}
    </div>
  );
}
